<template>
  <DashboardHeader>
    <v-layout>
      <Loader></Loader>
      <v-flex xs12 md3>
        <v-card class="mx-4 mt-4" shaped elevation="12" max-width="344" outlined>
          <h3 class="mx-5 mt-4">
            <v-icon>mdi-office</v-icon>Learning Materials
          </h3>
        </v-card>

        <v-card class="mx-4 mt-4" shaped elevation="12" max-width="344" outlined>
          <v-list-item three-line>
            <v-select
              v-model="selectedGradeId"
              :items="grades"
              item-text="name"
              item-value="id"
              label="Select Grade"
            ></v-select>
          </v-list-item>
        </v-card>

        <v-card
          v-if="selectedGradeId != null"
          class="mx-4 mt-4"
          shaped
          elevation="12"
          max-width="344"
          outlined
        >
          <v-list-item three-line>
            <v-select
              v-model="selectedSubjectId"
              :items="subjects"
              item-text="name"
              item-value="id"
              label="Select Subject"
              @change="getSelectedTopics()"
            ></v-select>
          </v-list-item>
        </v-card>

        <v-card
          v-if="selectedSubjectId != null && selectedGradeId != null"
          class="mx-4 mt-4"
          shaped
          elevation="12"
          max-width="344"
          outlined
        >
          <v-list-item three-line>
            <v-select
              v-model="selectedTopicId"
              :items="topics"
              item-text="name"
              item-value="id"
              label="Select Topic"
              @change="getSelectedDocs()"
            ></v-select>
          </v-list-item>
        </v-card>

        <v-card
          v-if="selectedSubjectId != null && selectedGradeId != null && selectedTopicId != null"
          class="mx-4 mt-4"
          shaped
          elevation="12"
          max-width="344"
          outlined
        >
          <v-list-item three-line>
            <v-select
              @change="getSelectedDoc()"
              v-model="selectedDoc"
              :items="docx"
              label="Select Word File"
            ></v-select>
          </v-list-item>
        </v-card>

        <v-card
          v-if="isStaff && selectedSubjectId != null && selectedGradeId != null && selectedTopicId != null"
          class="mx-4 mt-4 mb-2"
          shaped
          elevation="12"
          max-width="344"
          outlined
        >
          <v-file-input
            class="mb-2"
            show-size
            counter
            label="Click Here To Upload File"
            @change="getDocx()"
          ></v-file-input>
          <v-btn class="mx-6 my-2" rounded :color="getThemeColor" dark @click="uploadDoc()">Upload</v-btn>
        </v-card>
      </v-flex>
      <v-flex xs12 md8>
        <h5 v-if="docx.length == 0">
          No Lesson Materials Exist For The Selection Yet
          <br />
        </h5>

        <v-snackbar v-model="snackBar" dark :color="getThemeColor">
          {{ snackText }}
          <v-btn color="pink" text @click="snackBar = false">Close</v-btn>
        </v-snackbar>
        <v-card v-if="selectedDoc" class="mx-4 mt-4 mb-2" shaped elevation="12" outlined>
          <VueDocPreview v-if="mdiOffice" :value="iframeSource" type="office" />
          <iframe
            v-else-if="pdfViewer"
            :src="iframeSource"
            frameborder="0"
            width="100%"
            height="700"
          ></iframe>
        </v-card>
      </v-flex>
    </v-layout>
  </DashboardHeader>
</template>

<script>
import DashboardHeader from "@/components/DashboardHeader.vue";
import axios from "@/plugins/axios";
import VueDocPreview from "vue-doc-preview";
import Loader from "@/components/Loader.vue";

export default {
  computed: {
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getApiUrl() {
      return this.$store.getters.getApiUrl;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getCurrentUser() {
      return this.$store.getters.getCurrentUser;
    },

    isStaff() {
      return this.$store.getters.isStaff;
    }
  },
  components: {
    DashboardHeader,
    VueDocPreview,
    Loader
  },
  mounted() {
    axios.getData("/auth/all-subjects", this.getAccessToken).then(subjects => {
      this.subjects = subjects;
    });

    axios.getData("/auth/grades", this.getAccessToken).then(grades => {
      this.grades = grades;
    });
  },
  data() {
    return {
      mdiOffice: false,
      pdfViewer: false,
      subjects: [],
      topics: [],
      selectedSubjectId: null,
      selectedTopicId: null,
      grades: [],
      selectedGradeId: null,
      snackBar: false,
      snackText: "",
      iframeSource: "http://ieee802.org/secmail/docIZSEwEqHFr.doc",
      selectedDoc: null,
      docx: [],
      doc: null,
      filename: null
    };
  },
  methods: {
    getDocx() {
      const file = event.target.files[0];
      this.filename = file.name;

      const fileReader = new FileReader();

      fileReader.addEventListener("load", () => {
        this.doc = fileReader.result;
      });

      fileReader.readAsDataURL(file);
    },
    getSelectedDocs() {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/get-all-docs",
          {
            gradeId: this.selectedGradeId,
            subjectId: this.selectedSubjectId,
            topicId: this.selectedTopicId
          },
          this.getAccessToken
        )
        .then(response => {
          this.$store.commit("setLoader", false);
          this.docx = response;
        });
    },
    getSelectedDoc() {
      const parts = this.selectedDoc.split(".");
      const ext = parts[parts.length - 1];

      if (ext == "pdf") {
        this.mdiOffice = false;
        this.pdfViewer = true;
      } else {
        this.pdfViewer = false;
        this.mdiOffice = true;
      }
      this.iframeSource = this.getApiUrl + this.selectedDoc;
    },
    getSelectedTopics() {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/get-topics-for-subject-in-grade",
          {
            gradeId: this.selectedGradeId,
            subjectId: this.selectedSubjectId,
            topicId: this.selectedTopicId
          },
          this.getAccessToken
        )
        .then(topics => {
          this.topics = topics;
          this.$store.commit("setLoader", false);
        });
    },
    uploadDoc() {
      if (this.doc != null) {
        this.$store.commit("setLoader", true);
        axios
          .postDataWithToken(
            "/auth/upload-docs",
            {
              doc: this.doc,
              name: this.filename,
              gradeId: this.selectedGradeId,
              subjectId: this.selectedSubjectId,
              topicId: this.selectedTopicId
            },
            this.getAccessToken
          )
          .then(response => {
            this.$store.commit("setLoader", false);
            this.snackBar = true;
            this.snackText = "File Successfuly Uploaded";
            this.getSelectedDocs();
          });
      } else {
        event.preventDefault();
        alert("Make Sure A Proper File is Selected!");
      }
    }
  }
};
</script>

<style>
</style>